import React from 'react';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import OngoingConnectionStatusWidgetBody from './body';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';
import { getEventDetailsForDateFilter } from '../../../generic/Actions/WidgetActions/DateFilter/utils';
import { getEventDetailsHash } from '../utils';

/*
props = {
  actionsData: {
    exportChartAsPNG:
    exportChartAsCsv:
  }
  name: <string>,
  uId: <uniqueIdentifier>,
  bodyClassName: <string>,
  url: <string>,
  helpText: <string>,
  eventCategory: <string>,
  possibleMetricsCount: <string>,
  type: <string>
}
*/

export const exportEventName = "ongoingConnectionStatusExportChart";

const OngoingConnectionStatus = (props) => {
  const { name, url, actionsData } = props;
  const filterKey = "connectionStartedAt"
  const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, className: "grid-item-span-full-width" });
  const configBuilder = (state) => {
    return {
      remoteOptions: getRemoteConfigs(url, OngoingConnectionStatusWidgetBody, { filters: getCommonDateRangeWithPresetFilterValue(state, filterKey, 'connection_started_at_date_range')})
    };
  };

  const eventDetailsBuilder = (state) => {
    const { eventName, dateRange, preset } = getEventDetailsForDateFilter(state, { filterKey })

    return getEventDetailsHash({ eventName, source: name, dateRange, preset, eventCategory: props.eventCategory });
  }

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { exportEventName, eventDetailsBuilder });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      { ...widgetConfig.remoteOptions }
    />
  );
};

export default OngoingConnectionStatus;